import { action } from 'satcheljs';

export const linkedCalendarSelected = action(
    'LINKED_CALENDAR_SELECTED',
    (isSelected: boolean, forceReset?: boolean) => ({
        isSelected,
        forceReset,
    })
);
